module.exports = "/images/understanding-risk-2.jpeg?d2461216e34bb75cce970c05aca0716e";